import { makeComponent } from '../core';
import React from 'react';

export const Header = makeComponent( class extends React.Component<{$id:string,title:any}>{
    render(){
        return this.props.children || null;
    }
});

